/* eslint-disable @typescript-eslint/no-unused-vars */
import { getInternationalHolidays, getUkHolidays } from './fetchHelpers'
import { UKResponseFormat } from './holidays-types'

let ukHolidays: UKResponseFormat
let netherlands: string[]

async function getEnglandAndWales () {
  if (!ukHolidays) {
    ukHolidays = await getUkHolidays()
  }
  return ukHolidays['england-and-wales'].events.map(holiday => holiday.date)
}

async function getScotland () {
  if (!ukHolidays) {
    ukHolidays = await getUkHolidays()
  }
  return ukHolidays.scotland.events
    .filter(holiday => holiday.title !== 'St Andrew’s Day')
    .map(i => i.date)
}

async function getNetherlands () {
  // if (!netherlands) {
  //   netherlands = await getInternationalHolidays('en.dutch')
  // }
  return []
}

const fetchMap: Record<string, typeof getEnglandAndWales> = {
  'E&W': getEnglandAndWales,
  SCT: getScotland,
  NL: getNetherlands
}

export const fetchBankHolidays = async (region: string | undefined) => {
  if (typeof region === 'string') {
    const dataFunc = fetchMap[region]
    return dataFunc ? await dataFunc() : ['']
  }

  return ['']
}
